module.exports = __webpack_public_path__ + "img/img8.9a435d0.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/case/08/img8.jpg
// module id = 344
// module chunks = 0